import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('folder-accordion')
export class FolderAccordion extends LitElement {
    @property({ type: Boolean })
    opened?: boolean;

    @property({ type: Boolean })
    hasChildren?: boolean;

    @property({ type: Boolean })
    hasAncestors?: boolean;

    protected render() {
        return html`
            <div
                class="accordionPanel ${this.hasAncestors ?? false
                    ? 'hasAncestors'
                    : 'noAncestors'}">
                <div class="headingWrapper">
                    <slot name="heading"></slot>
                    ${this.hasChildren === true
                        ? html`
                              <mwc-icon class="toggleIcon" @click=${() => (this.opened = !(this.opened ?? false))}>${this.opened ?? false ? 'expand_less' : 'expand_more'}</mwc-icon>
                          `
                        : html`<div class="spacer"></div>`}
                </div>
                ${this.opened ?? false
                    ? html`
                          <div class="contentWrapper">
                              <slot name="content"></slot>
                          </div>
                      `
                    : ''}
            </div>
        `;
    }

    static get styles() {
        return css`
            .accordionPanel.noAncestors {
                width: 100%;
            }

            .headingWrapper {
                display: flex;
                align-items: center;
            }

            .headingName {
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            .spacer {
                width: 30px;
            }

            mwc-icon {
                cursor: pointer;
                margin-right: 0.5rem;
                size: 12px;
            }

            .toggleIcon {
                margin-left: 2px;
                margin-right: 7px;
                --mdc-icon-size: 16px;
            }

            .contentWrapper {
                padding-left: 0.5rem;
            }
        `;
    }
}
